import { useMountEffect } from '@react-hookz/web'
import { logEvent } from 'lib/tracking/segment'

type LogEventParams = Parameters<typeof logEvent>

/**
 * Logs a provided event on initial component render.
 * The hook created to have a convenient abstraction over the tracking service
 * in cases when we would like to track component mount
 * @param {string} event - descriptive event message
 * @param {object | undefined} props - additional event data
 * @returns {void}
 */
export const useLogEventOnMount = (...params: LogEventParams): void => {
  useMountEffect(() => {
    logEvent(...params)
  })
}
